module.exports = {
    "container": "mc1e338558_container",
    "button": "mc1e338558_button"
};